import { IMaterializedReference } from '../../schema/expressions/evaluate/materializeReferencePath';
import { createEvaluationVariables } from '../../schema/expressions/evaluate/variables/IEvaluationVariables';
import { IHydrationContext } from '../IHydrationContext';
import { getHydratedReferenceValue } from './getHydratedReferenceValue';

/**
 * Crea le variabili di valutazione per le espressioni nel contesto
 * di idratazione.
 *
 * Potremmo utilizzare anche qui `partitionReferences`, ma utilizzando
 * `getHydratedReferenceValue` possiamo semplificare il tutto.
 */
export function hydrateReferencesVariables(
  context: IHydrationContext,
  references: IMaterializedReference[],
) {
  const values = references.map(ref => getHydratedReferenceValue(context, ref));
  return createEvaluationVariables(references, values);
}
